module.exports = __webpack_public_path__ + "static/media/iphone-message-icon.b36035f9.png";